module.exports = __webpack_public_path__ + "img/expand-icon.27c6e2a9.svg";